
export const SozUndArbeitsAnamneseLeer = { SozUBeruf: {
    VERSION: '1.1',
    BESCHW: '',
    SCHM_YN: -1,
    BESCHW_VERLAUF: '',
    UNT_YN: -1,
    UNT_ROENTGEN: -1,
    UNT_CT: -1,
    UNT_MRT: -1,
    UNT_LAB: -1,
    UNT_BEL_EKG: -1,
    UNT_HERZ_KATH: -1,
    UNT_SONST: '',
    NICHT_OP_T_YN: -1,
    NICHT_OP_T_MEDI: -1,
    NICHT_OP_T_KG: -1,
    NICHT_OP_T_SONST: '',
    OP_YN: -1,
    OPERATIONEN: [ { DATUM: '', ART: ''},{ DATUM: '', ART: ''}, { DATUM: '', ART: ''} ],
    SELBST_YN: -1,
    SELBST: '',
    URSACHEN_YN: -1,
    URSACHEN: '',
    INFORMIERT_YN: -1,
    INFORMIERT: '',
    SCHWERWERKRANKUNGEN_YN: -1,
    DIABMELLITUS_YN: -1,
    DIABMELLITUS_SEIT: '',
    DIABMELLITUS_BEH: -1,
    DIABMELLITUS_INSULIN_YN: -1,
    DIABMELLITUS_INSULIN_SEIT: '',
    HYPERTONIE_YN: -1,
    HYPERTONIE_SEIT: '',
    KHK_YN: -1,
    KHK_RHYTM_YN: -1,
    KHK_RHYTM_SEIT: '',
    KHK_INFARKT_YN: -1,
    KHK_INFARKT_AM: '',
    KHK_KHK_YN: -1,
    KHK_KHK_SEIT: '',
    KHK_SONST_YN: -1,
    KHK_SONST: '',
    KHK_SONST_SEIT: '',
    CHOLESTERIN_YN: -1,
    CHOLESTERIN_SEIT: '',
    ANDEREKRANKHEITEN_YN: -1,
    ANDEREKRANKHEITEN: '',
    WEITERE_OPERATIONEN_YN: -1,
    WEITERE_OPERATIONEN: [ { DATUM: '', ART: ''},{ DATUM: '', ART: ''}, { DATUM: '', ART: ''} ],
    BEEINTRAECHTIGUNG_YN: 1,
    WENIG_INTERRESSE: 0,
    NIEDERGESCHLAGENHEIT: 0,
    NERVOSITAET: 0,
    SORGEN: 0,
    APPETIT: -1,
    UNVERTRAEGLICHKEITEN_YN: -1,
    UNVERTRAEGLICHKEITEN: '',
    AUSGEW_ERNAEHRUNG: -1,
    UEBELKEIT: -1,
    ERBRECHEN: -1,
    SODBRENNEN: -1,
    BLAEHUNGEN: -1,
    BAUCHSCHMERZEN: -1,
    STUHLGANG: -1,
    STUHLGANG_BLUT_YN: -1,
    DURCHFALL: -1,
    GROESSE: 0,
    GEWICHT_AKT: 0,
    GEWICHT_VOR1J: 0,
    GEWVERAENDERUNG: -1,
    GEW_BEMERKUNG: '',
    WASSERLASSEN_YN: -1,
    WASSERLASSEN: '',
    HARNDRANG_YN: -1,
    HARNDRANG_ANZ: 0,
    GESCHW_BEINE: -1,
    ATEMNOT: -1,
    HUSTEN: -1,
    AUSWURF: -1,
    SCHLAF: -1,
    SCHLAFSTOERUNG: 0,
    SCHLAFSTOERUNG_S: 0,
    SCHLAFSTOERUNG_G: 0,
    SCHLAFMITTEL: 0,
    ALLERGIEN_YN: -1,
    ALLERGIEN: '',
    NIKOTIN: -1,
    KEINNIKOTIN_SEIT: '',
    NIKOTIN_TAEGL: 0,
    NIKOTINTYP: 0,
    NIKOTIN_SEIT: 0,
    NIKOTIN_UNTERSTUETZNG: 0,
    ALKOHOL: -1,
    ALKOHOHL_BIER: 0,
    ALKOHOHL_BIER_ANZ: 0,
    ALKOHOL_BIER_TYP: 1,
    ALKOHOHL_WEIN: 0,
    ALKOHOHL_WEIN_ANZ: 0,
    ALKOHOHL_WEIN_TYP: 1,
    ALKOHOHL_SCHNAPS: 0,
    ALKOHOHL_SCHNAPS_ANZ: 0,
    ALKOHOHL_SCHNAPS_TYP: 1,
    MISSBRAUCH_AKTUELL: 0,
    MISSBRAUCH_WAR: 0,
    MISSBRAUCH: '',
    KINDER_ALTER: '',
    KINDER_UNTERHALT: 0,
    KINDER_UNTERHALT_WEGEN: [],
    KINDER_UNTERHALT_SONST: '',
    HAUSB_TREPPEN: 0,
    HIMI_KOMPRESSIONSSTRUEMPFE: 0,
    HIMI_BANDAGEN: 0,
    HIMI_KRUECKEN: 0,
    HIMI_ROLLATOR: 0,
    HIMI_ROLLSTUHL: 0,
    HIMI_HOERGERAET: 0,
    HIMI_SONST_YN: 0,
    HIMI_SONST: '',
    SPORTVERHALTEN: -1,
    ARBG_ALS: '',
    HEBEN_ART: '',
    HEBEN_SONST: '',
    ARBG_ZEITMODELL: -1,
    ARBG_BESCHREIBUNG: '',
    RAUCH: 0,
    LAERMSCHUTZ: 0,
    VIBRATION: 0,
    DAMPF_TXT: '',
    HAUTREIZUNG: 0,
    HAUTREIZUNG_TXT: '',
    ATEMREIZUNG: 0,
    ATEMREIZUNG_TXT: '',
    ARB_WO: 0,
    PKW: 0,
    LKW: 0,
    BAUMASCHINE: 0,
    PERSONENBEF: 0,
    GEFAHRGUT: 0,
    PUBLIKUM: 0,
    REISE: 0,
    MONTAGE: 0,
    MITARBEITERFUEHRUNG: 0,
    UNFALLGEFAHR: 0,
    KONZENTRATION: 0,
    ANFAHRTZEIT_YN: 0,
    ANFAHRTZEIT: 0,
    OHNEPAUSEN: 0,
    BILDSCHIRMARBEIT: 0,
    SEHVERMOEGEN: 0,
    AU_ZEITEN: [ { VON: '', BIS: '', WEGEN: ''},{ VON: '', BIS: '', WEGEN: ''},{ VON: '', BIS: '', WEGEN: ''},{ VON: '', BIS: '', WEGEN: ''} ],
    SELBSTEIN_ALLTAG: '',
    SELBSTEIN_HILFE: '',
    HILFE_KG: 0,
    HILFE_WARME: 0,
    HILFE_KAELTE: 0,
    HILFE_MEDI: 0,
    HILFE_BEWEGUNG: 0,
    HILFE_RUHE: 0,
    BERUFL_SITUATION: -1,
    BERUFL_SITUATION_TXT: '',
    BERUFL_SITUATION_KONSEQ: 0,
    BERUFL_SITUATION_NO: 0,
    ALLGEMEINES_TXT: '',
    NATIONALITAET: 39,
    FAMSTAND: -1,
    KINDER: 0,
    WOHNS: -1,
    WOHNS_SONST: '',
    HAUSH: -1,
    HAUSH_K: -1,
    HAUSF_U: -1,
    HAUSF_U_SONST: '',
    HAUSB: -1,
    HAUSB_SONST: '',
    SOZB_FAM: -1,
    SOZB_BER: -1,
    SOZB_FIN: 0,
    SOZB_SONST: 0,
    SOZB_SONST_TXT: '',
    SOZB_LES: 0,
    SOZB_SPR: 0,
    SCHW_GDB: 0,
    BEHINDGRAD: 0,
    SCHW_AUS: -1,
    BEHINDERUNG: '',
    BEHINDAUSWGUELTIG: '',
    SCHW_BEA: -1,
    SCHW_GLE: 0,
    SCHW_AEN: 0,
    PFL: -1,
    PFL_SONST: 0,
    PFL_BEA: 0,
    SPORT: '',
    HOBBY: '',
    VEREIN: '',
    FUE_A: 0,
    FUE_B: 0,
    FUE_C: 0,
    FUE_D: 0,
    FUE_S: 0,
    FUE_S_TXT: '',
    FUE_P: 0,
    RENTE: -1,
    RENTE_DAT: '',
    EXBERUF: '',
    ERWMRENTE: -1,
    ERWMRENTE_DAT: '',
    ERWMRENTE_BIS: 0,
    ERWMRENTE_BEFR: '',
    AU: -1,
    AU_DAT: '',
    AU_ZEIT: 0,
    AU_12: 0,
    SAB: -1,
    AUSB: -1,
    AUSB_ANG: '',
    LEHR_ZU: '',
    STUD_ALS: '',
    ZUSQ: 0,
    ZUSQ_TXT: '',
    UMSCH: 0,
    UMSCH_TXT: '',
    TAETIGKEITEN: '',
    BERUF: '',
    BERTYP: -1,
    BERTYP_DAT: '',
    ARBG: '',
    ARBG_DAT: '',
    ARBG_SIZE: -1,
    ARBG_ANZ: 0,
    ARBG_VTZ: 0,
    ARBG_UEB: -1,
    ARBG_UEBANZ: 0,
    ARBG_DIENST: -1,
    ARBG_BAND: -1,
    ARBG_AKK: -1,
    ARBG_SONST: 0,
    ARBG_SONST_TXT: '',
    ARBG_TEILZ_STD: 0,
    GEHEN: 0,
    SITZEN: 0,
    STEHEN: 0,
    HEBEN: -1,
    HEBEN_10: 0,
    HEBEN_15: 0,
    HEBEN_XX: 0,
    BUECKEN: 0,
    KNIEN: 0,
    UEBERK: 0,
    STEIGEN: 0,
    LAERM: 0,
    HITZE: 0,
    KAELTE: 0,
    NAESSE: 0,
    ZUG: 0,
    STAUB: 0,
    DAMPF: 0,
    BEL_SONST: 0,
    BEL_SONST_TXT: '',
    TECHN_HILF: '',
    PROBL_ARB: '',
    BETRARZT: -1,
    BETRARZT_DAT: '',
    ARBWEG: 0,
    ARBWEG_TYP: -1,
    SELBSTEIN: '',
    SELBSTAUS: -1,
    SELBSTAUS_TXT: '',
    SCHMERZLISTE: '',
    BETRARZT_TXT: ''
}};
